import { axios } from '../shared/axios';
import { jwtDecode } from 'jwt-decode';

const LOCAL_STORAGE_TOKEN = '99GIFT';

export const isValidJwt = (token) => {
  if (!token || typeof token !== 'string') return false;
  try {
    const decoded = jwtDecode(token);
    if (decoded?.exp) {
      const currentTime = Date.now() / 1000;
      if (decoded.exp <= currentTime) {
        return false;
      }
    }
    return true;
  } catch (e) {
    return false;
  }
};

export const getToken = () => {
  let auth = localStorage.getItem(LOCAL_STORAGE_TOKEN);

  if (auth) {
    try {
      const data = JSON.parse(auth);
      const token = data?.token;
      if (!token || typeof token !== 'string') {
        return null;
      }
      const decoded = jwtDecode(token);

      if (decoded?.exp) {
        const currentTime = Date.now() / 1000;
        if (decoded?.exp > currentTime) {
          return token;
        } else {
          userLogout(0);
          return null;
        }
      }
      return token;
    } catch (e) {
      return null;
    }
  } else {
    return null;
  }
};

export const apiFunction = async (url, method, postData, token, extraConfig) => {
  let config = {
    method,
    url,
  };
  if (method?.toLowerCase() === 'get') {
    config.params = postData || {};
  } else {
    config.data = postData || {};
  }

  if (token) {
    const authToken = getToken();

    config.headers = {
      Authorization: `Bearer ${authToken}`,
    };
  }

  // BLOB
  if (extraConfig === 'blob') {
    config.responseType = 'blob';
  }

  // MULTIPART
  if (extraConfig === 'multipart') {
    config.headers = {
      ...config.headers,
      'content-type': 'multipart/form-data',
    };
  }

  try {
    const apiResponse = await axios(config);
    if (apiResponse?.data?.messageCode?.startsWith('LOCATION_')) {
      localStorage.clear();
      sessionStorage.clear();
      if (window.location.pathname !== '/unauthorized') {
        window.location.href = '/unauthorized';
      }
      return false;
    }

    if (apiResponse?.status === 401) {
      userLogout();
      throw new Error('Please login again');
    }

    return {
      success: true,
      status: true,
      message: apiResponse?.data?.message || 'Success',
      statusCode: apiResponse.status,
      ...apiResponse.data,
    };
  } catch (err) {
    const statusCode = err?.response?.status || 500;
    const messageCode = err?.response?.data?.messageCode;

    if (messageCode?.startsWith('LOCATION_')) {
      localStorage.clear();
      sessionStorage.clear();
      if (window.location.pathname !== '/unauthorized') {
        window.location.href = '/unauthorized';
      }
      return false;
    }

    if (statusCode === 401) {
      userLogout();
      return;
    }
    return {
      success: false,
      status: false,
      message: err?.response?.data?.message || err.message || 'Something went wrong',
      statusCode,
      ...(err?.response?.data || null),
    };
  }
};

export const postFormDataAPI = async (url, postData, section) => {
  let token = getToken(section);
  if (!token) {
    return {
      status: false,
      message: 'Session expired. Please login again',
    };
  }

  let data;

  const config = {
    headers: {
      'content-type': 'multipart/form-data',
      token: `${token}`,
    },
  };

  await axios
    .post(url, postData, config)
    .then((res) => {
      data = res.data;
    })
    .catch((err) => {
      if (err?.response?.status === 401) {
        userLogout();
        data = {
          status: false,
          message: 'Session expired. Please login again',
        };
      } else {
        data = {
          ...err.response.data,
          status: false,
        };
      }
    });

  return data;
};

export const userTokenSave = (tokenData, metadata = {}) => {
  const token = typeof tokenData === 'string' ? tokenData : tokenData?.token;
  if (token && isValidJwt(token)) {
    try {
      let existingData = {};
      const existingRaw = localStorage.getItem(LOCAL_STORAGE_TOKEN);
      if (existingRaw) {
        try {
          existingData = JSON.parse(existingRaw);
        } catch (_) {}
      }
      localStorage.setItem(
        LOCAL_STORAGE_TOKEN,
        JSON.stringify({ ...existingData, token, ...metadata })
      );
      return true;
    } catch (e) {
      console.error('Failed to save user token to storage:', e);
      return false;
    }
  }
  return false;
};

export const userLogout = (timer = 1000) => {
  const token = localStorage.getItem(LOCAL_STORAGE_TOKEN);

  if (token) {
    localStorage.removeItem(LOCAL_STORAGE_TOKEN);
  }

  setTimeout(() => {
    window.location.reload();
  }, timer);

  return;
};
